export const GOOGLE_MAP_CONTAINER_STYLE = { width: '100%', height: '100%' } as const;

export function triggerMapResize(map: google.maps.Map, delayMs = 150): void {
  window.setTimeout(() => {
    google.maps.event.trigger(map, 'resize');
  }, delayMs);
}

export function getMapPopupOffset(width: number, height: number): { x: number; y: number } {
  return { x: -(width / 2), y: -(height + 36) };
}
